import type { CustomIconProps } from '../CustomIcon';

export const FednotLogoIcon = ({ color, size = 24 }: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path stroke={color} strokeWidth={2} d='M8 6.001h11M12 10.002h11M5 14.002h11M1 18.002h11' />
    </svg>
  );
};
